import React from 'react';
import PropTypes from 'prop-types';
import { Li } from './styles';
import { colors } from '../colorCodes';

export default class TreeElement extends React.Component {
    constructor(props) {
        super(props);
        this.onClickHandler = this.onClickHandler.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.active && this.props.active !== prevProps.active) {
            this.props.setActiveTab(this.props.name, this.props.level);
        }
    }

    onClickHandler() {
        this.props.onSelect(this.props.name);
        this.props.setActiveTab(this.props.name, this.props.level);
    }

    render() {
        return (
            <Li
                onClick={() => this.onClickHandler()}
                style={{
                    backgroundColor: this.props.isActive
                        ? colors.activeMenu
                        : colors.whiteText
                }}
            >
                {this.props.children}
            </Li>
        );
    }
}

TreeElement.propTypes = {
    children: PropTypes.node.isRequired,
    setActiveTab: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    active: PropTypes.bool.isRequired,
    level: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
};
